import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/compras/tipoAbono';
import Tipos from './TipoAbonoList';


const ms2p = (state) => {
  return {
    ...state.tipo_abono,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Tipos);
